// NewWebsiteRoutes

import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import About from "../../../NewWebsite/pages/About";
import Services from "../../../NewWebsite/pages/Services";
import Pricing from "../../../NewWebsite/pages/Pricing";
import Contact from "../../../NewWebsite/pages/Contact";
import SignUp from "../../../NewWebsite/pages/SignUp";
import SignIn from "../../../NewWebsite/pages/SignIn";
import NotFound from "../../../NewWebsite/pages/NotFound";
import Navbar from "../../../NewWebsite/components/layout/Navbar";
import Footer from "../../../NewWebsite/components/layout/Footer";
import Index from "../../../NewWebsite/pages/Index";
import theme from "./theme";
import "../../../NewWebsite/styles/global.css";
import ScrollToTop from "../ScrollToTop";
import ProviderSignIn from "../../../NewWebsite/pages/ProviderSignIn";
import ForgotPassword from "../../../NewWebsite/pages/ForgotPassword";
import PatientSignUp from "../../../NewWebsite/pages/PatientSignUp";
import PatientLogin from "../../../Container/Logins/PatientLogin";
import ProviderLogin from "../../../Container/Logins/ProviderLogin";


const queryClient = new QueryClient();

export default function NewWebsiteRoutes() {
  return (
    <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
    <ScrollToTop />
        <CssBaseline />
        <Navbar />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup" element={<PatientSignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/provider-signin" element={<ProviderSignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* <Route path="*" element={<NotFound />} /> */}
          <Route path="/patient-signin" element={<PatientLogin />} />
          <Route path="/provider-emr-login" element={<ProviderLogin />} />  
        </Routes>
        <Footer />
        </ThemeProvider>
    </QueryClientProvider>
  );
}
